/**
 * KAN-961: колонка высотой до низа экрана (useFillViewportHeight, режим height).
 * Список внутри (min-h-0 overflow-auto) тянется вниз и сжимается, панель под
 * ним (пагинация, shrink-0) стоит у низа экрана, без магических calc(100vh).
 */
import type { ReactNode } from 'react';
import { useFillViewportHeight } from '@/hooks/useFillViewportHeight';
import { cn } from '@/lib/utils';

interface FillViewportColumnProps {
  children: ReactNode;
  className?: string;
  'data-testid'?: string;
}

export function FillViewportColumn({ children, className, ...props }: FillViewportColumnProps) {
  const fill = useFillViewportHeight<HTMLDivElement>({ mode: 'height' });
  return (
    <div
      ref={fill.ref}
      style={fill.style}
      className={cn('flex min-h-0 flex-col', className)}
      data-testid={props['data-testid']}
    >
      {children}
    </div>
  );
}
